// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.1
// source: user-feedback.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";

export const protobufPackage = "com.tick2trade.api.userfeedback";

export enum FeedbackCategory {
  CATEGORY_UNKNOWN = 0,
  BUG = 1,
  FEEDBACK = 2,
  UNRECOGNIZED = -1,
}

export function feedbackCategoryFromJSON(object: any): FeedbackCategory {
  switch (object) {
    case 0:
    case "CATEGORY_UNKNOWN":
      return FeedbackCategory.CATEGORY_UNKNOWN;
    case 1:
    case "BUG":
      return FeedbackCategory.BUG;
    case 2:
    case "FEEDBACK":
      return FeedbackCategory.FEEDBACK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FeedbackCategory.UNRECOGNIZED;
  }
}

export function feedbackCategoryToJSON(object: FeedbackCategory): string {
  switch (object) {
    case FeedbackCategory.CATEGORY_UNKNOWN:
      return "CATEGORY_UNKNOWN";
    case FeedbackCategory.BUG:
      return "BUG";
    case FeedbackCategory.FEEDBACK:
      return "FEEDBACK";
    case FeedbackCategory.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MediaType {
  MEDIA_TYPE_UNKNOWN = 0,
  IMAGE = 1,
  VIDEO = 2,
  UNRECOGNIZED = -1,
}

export function mediaTypeFromJSON(object: any): MediaType {
  switch (object) {
    case 0:
    case "MEDIA_TYPE_UNKNOWN":
      return MediaType.MEDIA_TYPE_UNKNOWN;
    case 1:
    case "IMAGE":
      return MediaType.IMAGE;
    case 2:
    case "VIDEO":
      return MediaType.VIDEO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MediaType.UNRECOGNIZED;
  }
}

export function mediaTypeToJSON(object: MediaType): string {
  switch (object) {
    case MediaType.MEDIA_TYPE_UNKNOWN:
      return "MEDIA_TYPE_UNKNOWN";
    case MediaType.IMAGE:
      return "IMAGE";
    case MediaType.VIDEO:
      return "VIDEO";
    case MediaType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface FeedbackMediaItem {
  s3Key: string;
  type: MediaType;
}

export interface SubmitFeedbackRequest {
  category: FeedbackCategory;
  text: string;
  media: FeedbackMediaItem[];
}

export interface SubmitFeedbackResponse {
  id: string;
}

function createBaseFeedbackMediaItem(): FeedbackMediaItem {
  return { s3Key: "", type: 0 };
}

export const FeedbackMediaItem = {
  encode(message: FeedbackMediaItem, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.s3Key !== "") {
      writer.uint32(10).string(message.s3Key);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FeedbackMediaItem {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFeedbackMediaItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.s3Key = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FeedbackMediaItem {
    return {
      s3Key: isSet(object.s3Key) ? globalThis.String(object.s3Key) : "",
      type: isSet(object.type) ? mediaTypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: FeedbackMediaItem): unknown {
    const obj: any = {};
    if (message.s3Key !== "") {
      obj.s3Key = message.s3Key;
    }
    if (message.type !== 0) {
      obj.type = mediaTypeToJSON(message.type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FeedbackMediaItem>, I>>(base?: I): FeedbackMediaItem {
    return FeedbackMediaItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FeedbackMediaItem>, I>>(object: I): FeedbackMediaItem {
    const message = createBaseFeedbackMediaItem();
    message.s3Key = object.s3Key ?? "";
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseSubmitFeedbackRequest(): SubmitFeedbackRequest {
  return { category: 0, text: "", media: [] };
}

export const SubmitFeedbackRequest = {
  encode(message: SubmitFeedbackRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.category !== 0) {
      writer.uint32(8).int32(message.category);
    }
    if (message.text !== "") {
      writer.uint32(18).string(message.text);
    }
    for (const v of message.media) {
      FeedbackMediaItem.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubmitFeedbackRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubmitFeedbackRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.text = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.media.push(FeedbackMediaItem.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubmitFeedbackRequest {
    return {
      category: isSet(object.category) ? feedbackCategoryFromJSON(object.category) : 0,
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      media: globalThis.Array.isArray(object?.media) ? object.media.map((e: any) => FeedbackMediaItem.fromJSON(e)) : [],
    };
  },

  toJSON(message: SubmitFeedbackRequest): unknown {
    const obj: any = {};
    if (message.category !== 0) {
      obj.category = feedbackCategoryToJSON(message.category);
    }
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.media?.length) {
      obj.media = message.media.map((e) => FeedbackMediaItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubmitFeedbackRequest>, I>>(base?: I): SubmitFeedbackRequest {
    return SubmitFeedbackRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubmitFeedbackRequest>, I>>(object: I): SubmitFeedbackRequest {
    const message = createBaseSubmitFeedbackRequest();
    message.category = object.category ?? 0;
    message.text = object.text ?? "";
    message.media = object.media?.map((e) => FeedbackMediaItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSubmitFeedbackResponse(): SubmitFeedbackResponse {
  return { id: "" };
}

export const SubmitFeedbackResponse = {
  encode(message: SubmitFeedbackResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubmitFeedbackResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubmitFeedbackResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubmitFeedbackResponse {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: SubmitFeedbackResponse): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubmitFeedbackResponse>, I>>(base?: I): SubmitFeedbackResponse {
    return SubmitFeedbackResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubmitFeedbackResponse>, I>>(object: I): SubmitFeedbackResponse {
    const message = createBaseSubmitFeedbackResponse();
    message.id = object.id ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
